import React from 'react';
import { Card, Form, Table, Button, InputGroup } from 'react-bootstrap';
import { FaTrash, FaPlus, FaListAlt } from 'react-icons/fa';
import { useMenuContext } from '../context/MenuContext';

export const SpecificAddonsTab = () => {
  const { productModGroups, setProductModGroups, handleShowModBom } = useMenuContext();

  const handleAddSpecificGroupRow = () => {
    const newGroup = { id: null, name: "New Add-on", is_required: false, max_choices: 1, is_active: true, choices: [] };
    setProductModGroups([...productModGroups, newGroup]);
  };

  const handleSpecificGroupChange = (index, field, value) => {
    const updated = [...productModGroups];
    updated[index][field] = value;
    setProductModGroups(updated);
  };

  const handleSpecificChoiceChange = (groupIndex, choiceIndex, field, value) => {
    const updated = [...productModGroups];
    if (!updated[groupIndex].choices) updated[groupIndex].choices = [];
    updated[groupIndex].choices[choiceIndex][field] = value;
    setProductModGroups(updated);
  };

  const handleAddSpecificChoiceRow = (groupIndex) => {
    const newChoice = { id: null, name: "", price_adjust: 0, is_default: false, is_active: true };
    
    const updated = [...productModGroups];
    if (!updated[groupIndex].choices) updated[groupIndex].choices = [];
    updated[groupIndex].choices.push(newChoice);
    setProductModGroups(updated);
  };

  const handleInlineDelete = (type, groupIndex, choiceIndex = null) => {
    const updatedGroups = [...productModGroups];
    if (type === 'group') {
      updatedGroups.splice(groupIndex, 1);
    } else if (type === 'choice') {
      updatedGroups[groupIndex].choices.splice(choiceIndex, 1);
    }
    setProductModGroups(updatedGroups);
  };

  return (
    <div className="py-2">
      <p className="text-muted mb-3">Create specific modifiers that belong ONLY to this menu. Changes will be saved together when you click Save Menu Item.</p>
      
      {productModGroups.map((group, groupIndex) => (
        <Card key={group.id || groupIndex} className="mb-4 shadow-sm border border-secondary rounded">
          <Card.Header className="bg-white p-3 border-bottom d-flex flex-wrap gap-3 align-items-center">
            <div style={{ flex: 1, minWidth: "200px" }}>
              <Form.Label className="small text-muted mb-1 fw-bold">Group Name</Form.Label>
              <Form.Control type="text" value={group.name} 
                onChange={(e) => handleSpecificGroupChange(groupIndex, 'name', e.target.value)}
              />
            </div>
            <div style={{ width: "100px" }}>
              <Form.Label className="small text-muted mb-1 fw-bold">Required?</Form.Label>
              <div className="mt-2 text-center">
                <Form.Check type="checkbox" checked={group.is_required} 
                  onChange={(e) => handleSpecificGroupChange(groupIndex, 'is_required', e.target.checked)}
                />
              </div>
            </div>
            <div style={{ width: "120px" }}>
              <Form.Label className="small text-muted mb-1 fw-bold">Max Choices</Form.Label>
              <Form.Control type="number" min="1" value={group.max_choices} 
                onChange={(e) => handleSpecificGroupChange(groupIndex, 'max_choices', e.target.value)}
              />
            </div>
            <div style={{ width: "100px" }}>
              <Form.Label className="small text-muted mb-1 fw-bold">Active?</Form.Label>
              <div className="mt-2 text-center">
                <Form.Check type="switch" checked={group.is_active !== false && group.is_active !== 0} 
                  onChange={(e) => handleSpecificGroupChange(groupIndex, 'is_active', e.target.checked)}
                />
              </div>
            </div>
            <div className="mt-3 mt-md-0 pt-md-4 d-flex gap-2">
              <Button variant="outline-primary" size="sm" onClick={() => handleAddSpecificChoiceRow(groupIndex)}>
                <FaPlus /> Add Choice
              </Button>
              <Button variant="outline-danger" size="sm" onClick={() => handleInlineDelete('group', groupIndex)}>
                <FaTrash /> Remove
              </Button>
            </div>
          </Card.Header>
          <Card.Body className="p-0">
            <Table size="sm" bordered hover className="m-0 align-middle">
              <thead className="bg-light">
                <tr>
                  <th className="px-3" style={{ width: "40%" }}>Choice Name</th>
                  <th style={{ width: "20%" }}>Price Adjust (+THB)</th>
                  <th className="text-center" style={{ width: "15%" }}>Is Default?</th>
                  <th className="text-center" style={{ width: "10%" }}>Active?</th>
                  <th className="text-center" style={{ width: "10%" }}>Recipe</th>
                  <th className="text-center" style={{ width: "10%" }}>Delete</th>
                </tr>
              </thead>
              <tbody>
                {(!group.choices || group.choices.length === 0) ? (
                  <tr><td colSpan={5} className="text-center py-3 text-muted">No choices yet.</td></tr>
                ) : group.choices.map((choice, choiceIndex) => (
                  <tr key={choice.id || choiceIndex}>
                    <td className="px-3">
                      <Form.Control type="text" size="sm" placeholder="Enter choice name" value={choice.name} 
                        onChange={(e) => handleSpecificChoiceChange(groupIndex, choiceIndex, 'name', e.target.value)}
                      />
                    </td>
                    <td>
                      <InputGroup size="sm">
                        <InputGroup.Text>฿</InputGroup.Text>
                        <Form.Control type="number" step="0.01" value={choice.price_adjust} 
                          onChange={(e) => handleSpecificChoiceChange(groupIndex, choiceIndex, 'price_adjust', e.target.value)}
                        />
                      </InputGroup>
                    </td>
                    <td className="text-center">
                      <Form.Check type="checkbox" checked={choice.is_default} 
                        onChange={(e) => handleSpecificChoiceChange(groupIndex, choiceIndex, 'is_default', e.target.checked)}
                      />
                    </td>
                    <td className="text-center">
                      <Form.Check type="switch" checked={choice.is_active !== false && choice.is_active !== 0} 
                        onChange={(e) => handleSpecificChoiceChange(groupIndex, choiceIndex, 'is_active', e.target.checked)}
                      />
                    </td>
                    <td className="text-center">
                      <Button variant="outline-secondary" size="sm" onClick={() => handleShowModBom({ ...choice, groupIndex, choiceIndex })} title="Edit Recipe"><FaListAlt /></Button>
                    </td>
                    <td className="text-center">
                      <Button variant="outline-danger" size="sm" onClick={() => handleInlineDelete('choice', groupIndex, choiceIndex)}>
                        <FaTrash />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      ))}

      <Button variant="primary" style={{ background: "#1e3c72", border: "none" }} onClick={handleAddSpecificGroupRow}>
        <FaPlus className="me-2" /> Add Specific Group
      </Button>
    </div>
  );
};
